export default __webpack_public_path__ + "static/media/home.91d9befc.png";